import React from "react";
import { useTranslation } from "react-i18next";
import SFButton from "../../button";
import { SFStack } from "../../grid";
import { ACTION_TYPES } from "./actionTypes";

const Actions = ({ onClickAction }) => {
  const { t } = useTranslation();

  return (
    <>
      <SFStack direction="row" justifyContent="flex-end" spacing={2}>
        <SFButton
          variant="utility"
          onClick={() => onClickAction(ACTION_TYPES.clearAll)}
        >
          <SFStack direction="row" spacing={0.5}>
            <span>
              {t("components.datagrid.filters.advancedQuery.clearAllLabel")}
            </span>
          </SFStack>
        </SFButton>
        <SFButton
          variant="utility"
          onClick={() => onClickAction(ACTION_TYPES.saveQuery)}
        >
          <SFStack direction="row" spacing={0.5}>
            <span>
              {t("components.datagrid.filters.advancedQuery.saveQueryLabel")}
            </span>
          </SFStack>
        </SFButton>
        <SFButton
          variant="secondary"
          onClick={() => onClickAction(ACTION_TYPES.cancelQuery)}
        >
          {t("components.datagrid.filters.advancedQuery.cancelQueryLabel")}
        </SFButton>
        <SFButton
          variant="primary"
          onClick={() => onClickAction(ACTION_TYPES.applyFilters)}
        >
          {t("components.datagrid.filters.advancedQuery.applyFiltersLabel")}
        </SFButton>
      </SFStack>
    </>
  );
};

export default Actions;
